<div class="oa-sheet receipts-dialog">
    <header class="oa-sheet__header">
        <h2 class="oa-sheet__title" mat-dialog-title>
            Recibos de #{{ proposal?.proposalNumber }} {{ proposal?.shortDescription }}
            <span class="oa-sheet__subtitle">{{ proposal?.client?.name }}</span>
        </h2>
        <button type="button" class="oa-icon-btn" mat-dialog-close aria-label="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </header>

    <div class="oa-sheet__body receipts-dialog__body">
        <div class="receipts-dialog__loading" *ngIf="loading" role="status">
            <mat-spinner diameter="28"></mat-spinner>
            <span>Carregando parcelas...</span>
        </div>

        <ng-container *ngIf="!loading">
            <p class="receipts-dialog__empty" *ngIf="!rows.length">Este orçamento não tem parcelas.</p>

            <ul class="receipts-dialog__list" *ngIf="rows.length" aria-label="Parcelas do orçamento">
                <li class="receipts-dialog__row" *ngFor="let row of rows">
                    <span class="receipts-dialog__text">
                        <b>{{ row.item.description }}</b>
                        <span class="receipts-dialog__meta">
                            <ng-container *ngIf="row.receipt; else status">
                                Recibo nº {{ row.receipt.receiptNumber }} · {{ row.receipt.issueDate | date:'dd/MM/yyyy' }}
                            </ng-container>
                            <ng-template #status>
                                <ng-container *ngIf="isPaid(row.item); else notPaid">Pago em {{ row.item.paidAt | date:'dd/MM/yyyy' }}</ng-container>
                                <ng-template #notPaid>{{ row.item.statusName || 'Aguardando pagamento' }}</ng-template>
                            </ng-template>
                        </span>
                    </span>
                    <b class="receipts-dialog__amount">{{ row.item.amount | currency:'BRL':'symbol':'1.2-2' }}</b>
                    <span class="receipts-dialog__action">
                        <button *ngIf="row.receipt" type="button" class="oa-btn oa-btn--secondary oa-btn--sm" (click)="openPdf(row.receipt)">
                            <mat-icon>picture_as_pdf</mat-icon>
                            PDF
                        </button>
                        <button *ngIf="!row.receipt && isPaid(row.item)" type="button" class="oa-btn oa-btn--primary oa-btn--sm"
                            [disabled]="busy" (click)="emit(row)">
                            <mat-icon>receipt_long</mat-icon>
                            Emitir recibo
                        </button>
                        <span *ngIf="!row.receipt && !isPaid(row.item)" class="oa-badge oa-badge--muted">Sem pagamento</span>
                    </span>
                </li>
            </ul>
        </ng-container>
    </div>

    <footer class="oa-sheet__footer">
        <button type="button" class="oa-btn oa-btn--ghost" (click)="openProposal()">Abrir orçamento</button>
        <button *ngIf="pendingReceipts.length > 1" type="button" class="oa-btn oa-btn--primary" [disabled]="busy" (click)="emitAll()">
            <mat-icon>receipt_long</mat-icon>
            Emitir os {{ pendingReceipts.length }} recibos
        </button>
    </footer>
</div>
